import React from 'react';

function Loader() {
  return (
    <div className="loader-wrap">
      <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
        <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
      </svg>

      <div className="loader-wrap-heading">
        <div className="loader-logo">
          <img src="/home1/assets/img/logo_light.png" alt="Botanicheska Logo" className="loader-logo-img" />
        </div>
        <div className="load-text">
          <span>B</span>
          <span>o</span>
          <span>t</span>
          <span>a</span>
          <span>n</span>
          <span>i</span>
          <span>c</span>
          <span>h</span>
          <span>e</span>
          <span>s</span>
          <span>k</span>
          <span>a</span>
        </div>
      </div>
    </div>
  );
}

export default Loader;
